import { Card, Tooltip } from 'antd';
import React from 'react';
import { MetricItem } from '../type';
import ValueWithChange from './ValueWithChange';

const AIHistoryStatsCard: React.FC<MetricItem> = ({
  title,
  value,
  unit,
  change,
  type,
  is_negative,
  pending,
}) => {
  return (
    <Card className='w-full sentiment-card' bodyStyle={{ padding: 0 }}>
      <Tooltip
        title={
          type == 2 || type == 3 || type == 4 ? (
            <div className='zl-para-400-12 color-white'>
              {type == 2 &&
                'Share of AI calls that answered the caller correctly, counted once per call (emails per alert)'}
              {type == 2 && !!pending && (
                <div>{`${pending} recent ${pending === 1 ? 'call is' : 'calls are'} still being reviewed and not counted yet`}</div>
              )}
              {type == 3 && 'Includes neutral and positive scores'}
              {type == 4 &&
                'Time saved = minutes of calls and emails handled by AI instead of your team'}
            </div>
          ) : null
        }
      >
        <div className={`zl-heading-14`}>{title}</div>
      </Tooltip>

      <ValueWithChange
        value={value}
        unit={unit}
        change={change}
        is_negative={is_negative}
      />
    </Card>
  );
};

export default AIHistoryStatsCard;
